document.learnMore = document.querySelector('.learn-more');
let btnClose = document.querySelector('.learn-more-content .btn-close');
let learnMoreBtn =  document.querySelector('.learn-more-content');

btnClose.addEventListener('click', function(e) {
     learnMoreBtn.style.setProperty('display', `none`);
     learnMoreBtn.classList.remove('active');
});

document.learnMore.addEventListener('click', function(e) {
   document.learnMoreContent = document.querySelector('.learn-more-content');
   if (document.learnMoreContent.classList.contains('active')) {
     document.learnMoreContent.style.setProperty('display', `none`);
     document.learnMoreContent.classList.remove('active');
   } else {
      document.learnMoreContent.style.setProperty('display', `block`);
      document.learnMoreContent.classList.add('active');
   }
});